import { z } from 'zod';
export const changeLoginEmailRequestParamsSchema = z.object({
    accountId: z.string(),
    newEmail: z.string(),
});
